import { DateTime } from 'luxon';
import React, { useContext } from 'react';
import { Button, LocaleContext } from 'shared';

import {
  ApplicationBoxWrapper,
  ApplicationDescription,
  ApplicationHeader,
  ApplicationName,
} from './ApplicationBox.styles';
import { ApplicationBoxProps } from './ApplicationBox.types';

export const ApplicationBox = (application: ApplicationBoxProps) => {
  const localeContext = useContext(LocaleContext);

  return (
    <ApplicationBoxWrapper className="application">
      <ApplicationHeader className="application__header">
        <span className="application__created-date">
          {localeContext.formatMessage({ id: 'GENERAL.CREATED' })}:{' '}
          {DateTime.fromISO(application.createdAt).toLocaleString(DateTime.DATE_SHORT)}
        </span>
        <Button type="select" className="selected application__env">
          {application.environment}
        </Button>
      </ApplicationHeader>
      <ApplicationName className="application__header">{application.name}</ApplicationName>
      <ApplicationDescription className="application__description">{application.description}</ApplicationDescription>
    </ApplicationBoxWrapper>
  );
};
